// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1qDjN","fileBtn":"File_fileBtn__NzChf","closeBtn":"File_closeBtn__1kgBl","fileSelected":"File_fileSelected__2qGXg","disabled":"File_disabled__NPp1n"};